// Types
import Strategy from 'app/types/Strategy';
import MixpanelEvents from 'app/features/mixpanel/MixpanelEvents';
// Services
import Mixpanel from "app/services/Mixpanel.service";

export const handleCasePageUpdateConflictStrategy:Strategy = (payload, { accountId, userId, caseId }) => {
  const { documentId, pageNum } = payload;
  Mixpanel.track(MixpanelEvents.CasePageUpdateConflict, {
    accountId,
    userId,
    caseId,
    documentId,
    pageNum
  });
};

export const handleCaseEpisodeUpdateConflictStrategy:Strategy = (payload, { accountId, userId, caseId }) => {
  const { episodeId } = payload;
  Mixpanel.track(MixpanelEvents.CaseEpisodeUpdateConflict, {
    accountId,
    userId,
    caseId,
    episodeId
  });
};

export const handleCaseWorkspaceSwitchToEpisodeViewStrategy:Strategy = (_, { accountId, userId, caseId }) => {
  Mixpanel.track(MixpanelEvents.CaseWorkspaceSwitchToEpisodeView, {
    accountId,
    userId,
    caseId
  });
}

export const handleCaseWorkspaceSwitchToPagesViewStrategy:Strategy = (_, { accountId, userId, caseId }) => {
  Mixpanel.track(MixpanelEvents.CaseWorkspaceSwitchToPagesView, {
    accountId,
    userId,
    caseId
  });
}

export const handleCaseWorkspaceSendToAIChatStrategy:Strategy = (_, { accountId, userId, caseId }) => {
  Mixpanel.track(MixpanelEvents.CaseWorkspaceSendToAIChat, {
    accountId,
    userId,
    caseId
  });
}

export const handleCaseDocumentFocusModeEnterStrategy:Strategy = (_, { accountId, userId, caseId }) => {
  Mixpanel.track(MixpanelEvents.CaseDocumentFocusModeEnter, {
    accountId,
    userId,
    caseId
  });
}

export const handleCaseWorkspaceFocusModeEnterStrategy:Strategy = (_, { accountId, userId, caseId }) => {
  Mixpanel.track(MixpanelEvents.CaseWorkspaceFocusModeEnter, {
    accountId,
    userId,
    caseId
  });
}

export const handleCaseEpisodesViewStrategy:Strategy = (_, { accountId, userId, caseId }) => {
  Mixpanel.track(MixpanelEvents.CaseEpisodesView, {
    accountId,
    userId,
    caseId
  });
}

export const handleCaseAuditLogViewStrategy:Strategy = (_, { accountId, userId, caseId }) => {
  Mixpanel.track(MixpanelEvents.CaseAuditLogView, {
    accountId,
    userId,
    caseId
  });
}

export const handleCaseWorkflowsViewStrategy:Strategy = (_, { accountId, userId, caseId }) => {
  Mixpanel.track(MixpanelEvents.CaseWorkflowsView, {
    accountId,
    userId,
    caseId
  });
}

export const handleCaseTemplatesViewStrategy:Strategy = (_, { accountId, userId, caseId }) => {
  Mixpanel.track(MixpanelEvents.CaseTemplatesView, {
    accountId,
    userId,
    caseId
  });
}

export const handleCaseDocumentsNavBarOpenedStrategy:Strategy = (_, { accountId, userId, caseId }) => {
  Mixpanel.track(MixpanelEvents.CaseDocumentsNavBarOpened, {
    accountId,
    userId,
    caseId
  });
}

export const handleCaseDocumentsNavBarClosedStrategy:Strategy = (_, { accountId, userId, caseId }) => {
  Mixpanel.track(MixpanelEvents.CaseDocumentsNavBarClosed, {
    accountId,
    userId,
    caseId
  });
}

export const handleCasePagesBulkActionClickStrategy:Strategy = (payload, { accountId, userId, caseId }) => {
  const { action, numberOfPages } = payload;
  Mixpanel.track(MixpanelEvents.CasePagesBulkAction, {
    accountId,
    userId,
    caseId,
    action,
    numberOfPages
  });
}

export const handleCasePagesSwitchToNewDesignStrategy:Strategy = (_, { accountId, userId, caseId }) => {
  Mixpanel.track(MixpanelEvents.CasePagesSwitchToNewDesign, {
    accountId,
    userId,
    caseId
  });
}

export const handleCasePagesSwitchToOldDesignStrategy:Strategy = (_, { accountId, userId, caseId }) => {
  Mixpanel.track(MixpanelEvents.CasePagesSwitchToOldDesign, {
    accountId,
    userId,
    caseId
  });
}

export const handleCaseReportPreviewOpenedClickStrategy:Strategy = (payload, { accountId, userId, caseId }) => {
  const { reportId } = payload;
  Mixpanel.track(MixpanelEvents.CaseReportPreviewOpened, {
    accountId,
    userId,
    caseId,
    reportId
  });
}

export const handleCaseDocumentCreatedStrategy:Strategy = (payload, { accountId, userId, caseId }) => {
  const { documentId } = payload;
  Mixpanel.track(MixpanelEvents.CaseDocumentCreated, {
    accountId,
    userId,
    caseId,
    documentId
  });
}

export const handleCaseDocumentDeletedStrategy:Strategy = (payload, { accountId, userId, caseId }) => {
  const { documentId } = payload;
  Mixpanel.track(MixpanelEvents.CaseDocumentDeleted, {
    accountId,
    userId,
    caseId,
    documentId
  });
}
